
define(
    'Tavano.TavanoteamGA4.TTGA4.Utils'
    , [
        'underscore'
    ]
    , function (
        _
    ) {
        'use strict';
        var isMinVersion = isBundleMinVersion();
        var engagementToken = 0;
        var pendingEngagementTeardown = null;
        var pendingEngagementExitFlush = null;
        /**
         * Defers TT_page_view until min time on page + at least one user interaction.
         * Cancels previous pending view when a new URL is scheduled (SPA navigation).
         * Strong interactions (click, scroll, key, touch, tab visible again) use a shorter min time.
         * On SPA navigation, flushes TT_page_view for the previous URL if the user had a strong
         * interaction but left before the long window (fast click-through).
         * Optional: flags perfectly regular mousemove intervals as bot-like unless another channel fired (scroll, key, click, touch).
         */
        function scheduleEngagedPageView(pageUrl, options) {
            options = options || {};
            var minMs = typeof options.minEngagementMs === 'number' ? options.minEngagementMs : 3000;
            var minMsStrong = typeof options.minEngagementMsStrong === 'number' ? options.minEngagementMsStrong : 500;
            var minMsRapidNavigate = typeof options.minEngagementMsRapidNavigate === 'number' ? options.minEngagementMsRapidNavigate : 120;
            var checkLinearMouse = options.checkLinearMouse !== false;
            if (pendingEngagementExitFlush) {
                pendingEngagementExitFlush();
                pendingEngagementExitFlush = null;
            }
            if (pendingEngagementTeardown) {
                pendingEngagementTeardown();
            }
            engagementToken += 1;
            var myToken = engagementToken;
            var startTime = Date.now();
            var hasInteraction = false;
            var nonMouseInteraction = false;
            var lastMoveTime = 0;
            var moveIntervals = [];
            var linearMouseSuspect = false;
            var pollId = null;
            function teardown() {
                if (pollId !== null) {
                    clearInterval(pollId);
                    pollId = null;
                }
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('pointermove', onPointerMove);
                document.removeEventListener('scroll', onScroll, true);
                document.removeEventListener('keydown', onKeyDown);
                document.removeEventListener('click', onClick);
                document.removeEventListener('touchstart', onTouchStart, { capture: true });
                document.removeEventListener('visibilitychange', onVisibilityChange);
                pendingEngagementTeardown = null;
                pendingEngagementExitFlush = null;
            }
            function passesTimeRules(elapsed, forExitFlush) {
                if (!hasInteraction) {
                    return false;
                }
                var needMs = nonMouseInteraction ? minMsStrong : minMs;
                if (elapsed >= needMs) {
                    return true;
                }
                if (forExitFlush && nonMouseInteraction && elapsed >= minMsRapidNavigate) {
                    return true;
                }
                return false;
            }
            function passesLinearMouseRules() {
                if (checkLinearMouse && linearMouseSuspect && !nonMouseInteraction) {
                    return false;
                }
                return true;
            }
            function tryFire() {
                if (myToken !== engagementToken) {
                    return;
                }
                var elapsed = Date.now() - startTime;
                if (!passesTimeRules(elapsed, false) || !passesLinearMouseRules()) {
                    return;
                }
                teardown();
                pushToDataLayer({
                    event: 'TT_page_view'
                    , data: {
                        page: pageUrl
                    }
                });
            }
            function exitFlushBeforeNextPage() {
                if (myToken !== engagementToken) {
                    return;
                }
                var elapsed = Date.now() - startTime;
                if (!passesTimeRules(elapsed, true) || !passesLinearMouseRules()) {
                    return;
                }
                pushToDataLayer({
                    event: 'TT_page_view'
                    , data: {
                        page: pageUrl
                    }
                });
            }
            function markNonMouse() {
                nonMouseInteraction = true;
                hasInteraction = true;
                tryFire();
            }
            function onMouseMove() {
                recordMouseInterval();
                hasInteraction = true;
                tryFire();
            }
            function onPointerMove(e) {
                if (e.pointerType === 'mouse') {
                    recordMouseInterval();
                }
                hasInteraction = true;
                tryFire();
            }
            function recordMouseInterval() {
                var now = Date.now();
                if (lastMoveTime) {
                    moveIntervals.push(now - lastMoveTime);
                    if (moveIntervals.length > 8) {
                        moveIntervals.shift();
                    }
                    if (moveIntervals.length >= 6) {
                        var first = moveIntervals[0];
                        linearMouseSuspect = moveIntervals.every(function (interval) {
                            return Math.abs(interval - first) < 2;
                        });
                    }
                }
                lastMoveTime = now;
            }
            function onScroll() {
                markNonMouse();
            }
            function onKeyDown() {
                markNonMouse();
            }
            function onClick() {
                markNonMouse();
            }
            function onTouchStart() {
                markNonMouse();
            }
            var tabWasHidden = document.visibilityState === 'hidden';
            function onVisibilityChange() {
                if (document.visibilityState === 'hidden') {
                    tabWasHidden = true;
                } else if (document.visibilityState === 'visible' && tabWasHidden) {
                    tabWasHidden = false;
                    markNonMouse();
                }
            }
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('pointermove', onPointerMove);
            document.addEventListener('scroll', onScroll, true);
            document.addEventListener('keydown', onKeyDown);
            document.addEventListener('click', onClick);
            document.addEventListener('touchstart', onTouchStart, { capture: true });
            document.addEventListener('visibilitychange', onVisibilityChange);
            pollId = setInterval(tryFire, 250);
            pendingEngagementExitFlush = exitFlushBeforeNextPage;
            pendingEngagementTeardown = teardown;
        }
        function getApplication(ctx) {
            return _.isFunction(SC.Application) ? SC.Application(ctx) : SC.Application;
        }
        function getDataLayer() {
            return window.dataLayer || [];
        }
        function pushToDataLayer(data) {
            var tracker = getDataLayer();
            tracker.push(data);
        }
        function isBundleMinVersion() {
            var scVersion = SC.ENVIRONMENT.RELEASE_METADATA.version.split('.')
                , scVersionYear = new Date(scVersion[0]).getFullYear()
                , scVersionRelease = parseInt(scVersion[1])
                , isMinVersion = false;
            //minimum version supported by the addTracker extensibility
            //is 2021.1. We have to check the SC or SCA version in order to identify
            //if the extensibility is usable
            if (scVersionYear >= 2021 && scVersionRelease >= 1) {
                isMinVersion = true;
            }
            return isMinVersion;
        }
        // function addEventTrackerGA4(eventTrackerName, eventCallback)
        // {
        //     var env = SC.Application.getComponent('Environment')
        //     ,   eventTrackerObj = {};
        //     if(!eventTrackerObj.hasOwnProperty(eventTrackerName))
        //     {
        //         if(eventCallback && _.isFunction(eventCallback))
        //         {
        //             eventTrackerObj[eventTrackerName] = eventCallback;
        //         }
        //         else
        //         {
        //             eventTrackerObj[eventTrackerName] = function(data)
        //             {
        //                 pushToDataLayer(data);
        //             }
        //         }
        //     }
        //     console.log("eventTrackerObj", eventTrackerObj)
        //     env.addTracker(eventTrackerObj);
        // }
        function trackPageViewGA4(pageUrl, container, pagesource, options) {
            //console.log("pagesource", pagesource);
            if (pagesource == 'checkout') {
                //console.log("!window.isPageViewed", !window.isPageViewed)
                if (!window.isPageViewed) {
                    pushToDataLayer({
                        event: 'TT_page_view'
                        , data: {
                            page: pageUrl
                        }
                    });
                }
                window.isPageViewed = true;
            }
            else if (options && options.requireEngagement) {
                scheduleEngagedPageView(pageUrl, options);
            }
            else {
                pushToDataLayer({
                    event: 'TT_page_view'
                    , data: {
                        page: pageUrl
                    }
                });
            }
        }
        function trackLoginGA4(container, userid) {
            var eventData = {
                event: "TT_login"
                , data: {
                    method: "Web"
                    , client_id: userid
                }
            };
            pushToDataLayer(eventData);
        }
        function trackRegisterGA4(container) {
            var eventData = {
                event: "TT_sign_up"
                , data: {
                    method: "Web"
                }
            };
            pushToDataLayer(eventData);
        }
        function trackProductViewGA4(itemData, container) {
            var eventData = {
                event: 'TT_view_item'
                , data: itemData
            };
            pushToDataLayer(eventData);
        }
        function trackCartViewGA4(cartData, container) {
            var eventData = {
                event: 'TT_view_cart'
                , data: {
                    currency: cartData.currency
                    , items_cart: cartData.items
                    , value: cartData.value
                }
            };
            pushToDataLayer(eventData);
        }
        function trackAddToCartGA4(cartData, container) {
            pushToDataLayer({
                event: "TT_add_to_cart"
                , data: cartData
            });
        }
        function trackRemoveItemCartGA4(removedItemData, container) {
            var eventData = {
                event: 'TT_remove_from_cart'
                , data: removedItemData
            };
            // if(isMinVersion)
            // {
            //     var env = container.getComponent('Environment');
            //     addEventTrackerGA4('trackerRemoveItemInCart');
            //     env.triggerEvent('trackerRemoveItemInCart', eventData);
            // }
            // else
            // {
            pushToDataLayer(eventData);
            //}
        }
        function trackSearchGA4(query, method, container) {
            var eventData = {
                event: 'TT_search'
                , data: {
                    search_term: query
                    , search_method: method
                }
            };
            // if(isMinVersion)
            // {
            //     var env = container.getComponent('Environment');
            //     addEventTrackerGA4('trackSearchEvent', function(data)
            //     {
            //         pushToDataLayer(data);
            //     });
            //     env.triggerEvent('trackSearchEvent', eventData);
            // }
            // else
            // {
            pushToDataLayer(eventData);
            // }
        }
        function trackAddToWishlistGA4(itemData, container) {
            pushToDataLayer({
                event: 'TT_add_to_wishlist'
                , data: itemData
            });
        }
        function trackBeginCheckoutGA4(eventData, container) {
            //console.log("eventData checkout", eventData);
            pushToDataLayer({
                event: 'TT_proceed_to_checkout'
                , data: eventData
            });
        }
        function trackCheckoutInfoGA4(eventData) {
            pushToDataLayer({
                event: 'TT_begin_checkout'
                , data: eventData
            });
        }
        function trackShipInfoGA4(eventData, container) {
            if (!window.isShipInfoAdded) {
                pushToDataLayer({
                    event: 'TT_add_shipping_info'
                    , data: eventData
                });
                window.isShipInfoAdded = true;
            }
            window.isProfileLoaded = true;
        }
        function trackPaymentInfoGA4(eventData, container) {
            if (!window.isPaymentAdded) {
                pushToDataLayer({
                    event: 'TT_add_payment_info'
                    , data: eventData
                });
                window.isPaymentAdded = true;
            }
        }
        function trackPurchaseGA4(eventData, container) {
            pushToDataLayer({
                event: 'TT_purchase'
                , data: eventData
            });
        }
        function trackEnhancedConversion(eventData, container) {
            //console.log("TT_Test", eventData);
            setTimeout(function () {
                pushToDataLayer({
                    event: 'TT_Test'
                    , data: eventData
                });
            }, 5000);
        }
        function trackProductSelectGA4(eventData, container) {
            pushToDataLayer({
                event: "TT_select_item"
                , data: eventData
            });
        }
        function trackProductListGA4(eventData, container) {
            pushToDataLayer({
                event: "TT_view_item_list"
                , data: eventData
            })
        }
        function trackGenerateLead(eventData, container) {
            pushToDataLayer({
                event: "TT_generate_lead"
                , data: eventData
            });
        }
        function getCookieByName(name) {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (!match) {
                return null;
            }
            var decodedValue = decodeURIComponent(match[2]);
            try {
                var parsed = JSON.parse(decodedValue);
                return parsed;
            } catch (e) {
                // fallback: try to split comma-separated values
                if (decodedValue.includes(',')) {
                    return decodedValue.split(',');
                }
                // return plain string if no commas
                return decodedValue;
            }
        }
        // function getCookieByName(name) {
        //     var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        //     //returns null if there is no match
        //     if (match) {
        //         return match[2];
        //     }
        //     return match;
        // }
        function trackCheckoutAsGuestGA4() {
            var eventData = {
                event: "TT_guest_checkout"
                , data: {
                    method: "Web"
                }
            };
            pushToDataLayer(eventData);
        }
        var TTGA4Utils = {
            trackPageViewGA4: trackPageViewGA4
            , trackLoginGA4: trackLoginGA4
            , trackRegisterGA4: trackRegisterGA4
            , trackProductViewGA4: trackProductViewGA4
            , trackCartViewGA4: trackCartViewGA4
            , trackAddToCartGA4: trackAddToCartGA4
            , trackRemoveItemCartGA4: trackRemoveItemCartGA4
            , trackSearchGA4: trackSearchGA4
            , trackAddToWishlistGA4: trackAddToWishlistGA4
            , trackBeginCheckoutGA4: trackBeginCheckoutGA4
            , trackCheckoutInfoGA4: trackCheckoutInfoGA4
            , trackShipInfoGA4: trackShipInfoGA4
            , trackPaymentInfoGA4: trackPaymentInfoGA4
            , trackPurchaseGA4: trackPurchaseGA4
            , trackEnhancedConversion: trackEnhancedConversion
            , trackProductSelectGA4: trackProductSelectGA4
            , trackProductListGA4: trackProductListGA4
            , trackGenerateLead: trackGenerateLead
            , trackCheckoutAsGuestGA4: trackCheckoutAsGuestGA4
            , isBundleMinVersion: isBundleMinVersion
            , getApplication: getApplication
            , getCookieByName: getCookieByName
        };
        // _.mixin(TTGA4Utils);
        return TTGA4Utils;
    });
